export default __webpack_public_path__ + "static/media/mode-537.78824a45.svg";